import { api } from '@frontend/api-utils';
import { AuthenticationManager } from '@frontend/authentication-v2';
import { Logger } from '@frontend/logger';
import { SSOProviderClient } from '@frontend/sso/api';
import { PublicSSOProvider } from '@frontend/sso/types';
import { useEffect, useState } from 'react';

import { SsoProps } from './sso.component';

interface ViewProps {
    provider: PublicSSOProvider | null;
    url: string | null;
    onSsoClick: () => void;
}

const useSso = (props: SsoProps): ViewProps => {
    const params = new URLSearchParams(window.location.search);
    const [provider, setProvider] = useState<PublicSSOProvider | null>(null);

    useEffect(() => {
        SSOProviderClient.fetchProviderByDomain()
            .then(setProvider)
            .catch((error) => {
                Logger.warn('No SSO settings found for current domain.', error);
                setProvider(null);
            });
    }, []);

    useEffect(() => {
        const code = params.get('code');
        if (code && provider) {
            AuthenticationManager.getInstance()
                .ssoAuthenticate(provider.account_id, provider.id, code)
                .then(() => props.callback && props.callback());
        }
    }, [params, provider]);

    return {
        provider,
        url: provider && api(`/sso-api/v1/accounts/${provider.account_id}/providers/${provider.id}/login`),
        onSsoClick: () => AuthenticationManager.getInstance().prepareSsoLogin(props.keepLoggedIn ?? false)
    };
};

export default useSso;
